/**
 * Shared bank options for MultiSelect/Dropdown components.
 * Used in CreateLead, CollaborationDetails, and other forms.
 */
export const bankOptions = [
    { label: 'ICICI Bank', value: 'ICICI' },
    { label: 'State Bank of India', value: 'SBI' },
    { label: 'Kotak Mahindra Bank', value: 'KOTAK' },
    { label: 'Yes Bank', value: 'YES' },
    { label: 'HDFC Bank', value: 'HDFC' },
    { label: 'Axis Bank', value: 'AXIS' },
    { label: 'Punjab National Bank', value: 'PNB' },
    { label: 'Indusind Bank', value: 'INDUSIND' },
    { label: 'Central Bank of India', value: 'CENTRAL_BANK' },
    { label: 'Canara Bank', value: 'CANARA' },
    { label: 'Bank Of Baroda', value: 'BANK_OF_BARODA' },
    { label: 'Union Bank Of India', value: 'UNION_BANK' },
    { label: 'Bank Of India', value: 'BANK_OF_INDIA' },
    { label: 'IDBI Bank', value: 'IDBI' },
    { label: 'Bandhan Bank', value: 'BANDHAN' },
    { label: 'Federal Bank', value: 'FEDERAL' },
    { label: 'IDFC First Bank', value: 'IDFC' },
    { label: 'RBL Bank', value: 'RBL' },
    { label: 'South Indian Bank', value: 'SOUTH_INDIAN' },
    { label: 'Karnataka Bank', value: 'KARNATAKA' },
    { label: 'Jammu and Kashmir Bank', value: 'JAMMU_KASHMIR' },
    { label: 'City Union Bank', value: 'CITY_UNION' },
    { label: 'DCB Bank', value: 'DCB' },
    { label: 'Dhanlaxmi Bank', value: 'DHANLAXMI' },
    { label: 'Karur Vysya Bank', value: 'KARUR_VYASA' },
    { label: 'Lakshmi Vilas Bank', value: 'LAKSHMI_VILAS' },
    { label: 'Tamilnad Mercantile Bank', value: 'TAMILNAD_MERCANTILE' },
    { label: 'Catholic Syrian Bank', value: 'CATHOLIC_SYRIAN' },
    { label: 'Nainital Bank', value: 'NAINITAL' },
    { label: 'AU Small Finance Bank', value: 'AU_SMALL_FINANCE_BANK' },
    { label: 'Equitas Small Finance Bank', value: 'EQUITAS_SMALL_FINANCE_BANK' },
    { label: 'Ujjivan Small Finance Bank', value: 'UJJIVAN_SMALL_FINANCE_BANK' },
    { label: 'Jana Small Finance Bank', value: 'JANA_SMALL_FINANCE_BANK' },
    { label: 'Fincare Small Finance Bank', value: 'FINCARE_SMALL_FINANCE_BANK' },
    { label: 'ESAF Small Finance Bank', value: 'ESAF_SMALL_FINANCE_BANK' },
    { label: 'Suryoday Small Finance Bank', value: 'SURYODAY_SMALL_FINANCE_BANK' },
    { label: 'Utkarsh Small Finance Bank', value: 'UTKARSH_SMALL_FINANCE_BANK' },
    { label: 'North East Small Finance Bank', value: 'NORTH_EAST_SMALL_FINANCE_BANK' },
    { label: 'Capital Small Finance Bank', value: 'CAPITAL_SMALL_FINANCE_BANK_LTD' },
    { label: 'Shivalik Small Finance Bank', value: 'SHIVALIK_SMALL_FINANCE_BANK' },
    { label: 'Unity Small Finance Bank', value: 'UNITY_SMALL_FINANCE_BANK' },
    { label: 'Paytm Payments Bank', value: 'PAYTM_PAYMENTS_BANK' },
    { label: 'Airtel Payments Bank', value: 'AIRTEL_BANK' },
    { label: 'India Post Payments Bank', value: 'India_Post_Payments_Bank' },
    { label: 'Fino Payments Bank', value: 'FINO_PAYMENTS_BANK' },
    { label: 'NSDL Payments Bank', value: 'NSDL_PAYMENTS_BANK' },
    { label: 'Jio Payments Bank', value: 'JIO_PAYMENTS_BANK' },
    { label: 'Standard Chartered Bank', value: 'STANDARD_CHARTERED' },
    { label: 'Citi Bank', value: 'CITI' },
    { label: 'HSBC Bank', value: 'HSBC' },
    { label: 'Deutsche Bank', value: 'DEUTSCHE_BANK' },
    { label: 'DBS Bank', value: 'DBS' },
    { label: 'Barclays Bank', value: 'BARCLAYS_BANK' },
    { label: 'Bank of America', value: 'BANK_OF_AMERICA' },
    { label: 'Other', value: 'OTHER' }
];
